// const modelConfig1 = {
//   eventordereventjersey:{
//     900: {
//     overallScale: 9.917,
//     position: [0, -0.001, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.011, 0.012, 0.012],
//     // scale: [0.0165, 0.0165, 0.0165],
//     patternScalling: 100,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//       fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -8.5, -10],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [30, 14, 9],

//     frontNumberPosition: [0, -8.5, 1],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0100, 0.0100, 0.0090],

//     frontLogoPosition: [5, -8.5, 14],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0007, 0.0009],

//     backTextPosition: [0, 8.5, -10],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 14, 9],

//     backNumberPosition: [0, 8.5, 1],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.5000, 1.0400, 0.0900],

//     backLogoPosition: [-5, 10.5, 14],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0007, 0.0009],

//     logoPosition: [0, 0, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: [0.0001, 0.0001, 0.0001],
//   },
//    901: {
//     overallScale: 7.8,
//     position: [0, 0, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: [0.001,0.001,0.001],

//     patternScalling: 750,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//      fontSize: 120,
//     fontSizeNumber: 10,
    
//     frontTextPosition: [0, 137, 133],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [320, 160, 150],

//     frontNumberPosition: [0, 137, 33],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.9200, 0.4600, 0.4300],

//     frontLogoPosition: [60, 107, -140],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0070, 0.0050, 0.0050],

//     backTextPosition: [0, -137, 133],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [320, 160, 150],

//     backNumberPosition: [0, -137, 33],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [9.2000, 4.6000, 4.3000],

//     backLogoPosition: [-60, -137, -140],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0070, 0.0050, 0.0050],

//     // logoPosition: [0, 0.003, 0.038],
//     logoPosition: [0, 0.003, 0.029],
//     logoRotation: [-0.109, 0, 0],
//     logoScale: 0.017,
//   },
//  902: {
//    overallScale: 8.417,
//     position: [0, -0.003, -0.029],
//     rotation: [0, 0, 0],
//     // scale: 9.717,
//     scale: [1.717,1.717,1.717],

//     // designposition: [0, -0.003, -0.015],
//     // designrotation:[0, 0, 0],
//     // designscale: 1.717,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     patternScalling: 0.717,

//     fontSize: 120,
//     fontSizeNumber: 40,
//     frontTextPosition: [0, 0.05, 0.1],
//     frontTextRotation: [0, 0, 0],
//     // frontTextScale: [0.1, 0.07, 0.2],
//     frontTextScale: [0.19, 0.065, 0.2],

//     frontNumberPosition: [0, -0.06, 0.1],
//     frontNumberRotation: [0, 0, 0],
//     // frontNumberScale: [0.0020, 0.0008, 0.0001],
//     frontNumberScale: [0.0002, 0.0001, 0.0002],

//     frontLogoPosition: [0.04, 0.12, 0.1],
//     frontLogoRotation: [0, 0, 0],
//     frontLogoScale: [0.0000, 0.0000, 0.0000],

//     backTextPosition: [0, 0.05, -0.1],
//     backTextRotation: [0, Math.PI, 0],
//     // backTextScale: [0.25, 0.1, 0.1],
//     backTextScale: [0.19, 0.065, 0.2],

//     backNumberPosition: [0, -0.06, -0.1],
//     backNumberRotation: [0, Math.PI, 0],
//     // backNumberScale: [0.0200, 0.0077, 0.0010],
//     backNumberScale: [0.0020, 0.0015, 0.0020],

//     backLogoPosition: [-0.04, 0.13, -0.07],
//     backLogoRotation: [0, Math.PI, 0],
//     backLogoScale: [0.0000, 0.0000, 0.0000],

//     // logoPosition:[0, 0.003, 0.029],
//     // logoRotation: [-0.109, 0, 0],
//     // logoScale: 20.717,
//     logoPosition: [0, 0.003, 0.029],
//     logoRotation: [-0.109, 0, 0],
//     logoScale: 0.017,
//   },
//    903: {
//    overallScale: 6,
//     position: [0, -1.315, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: 0.001,
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     fontSize: 120,
//     fontSizeNumber: 30,

//      frontTextPosition: [0, 100, -1150],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [300, 250, 200],

//     frontNumberPosition: [0, 100, -1350],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.3000, 0.2500, 0.2000],

//     frontLogoPosition:  [60, 80, -1450],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0060, 0.0060, 0.0060],

//     backTextPosition: [0, -100, -1150],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [300, 250, 200],

//     backNumberPosition: [0, -100, -1350],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [3.0000, 2.5000, 2.0000],

//     backLogoPosition: [60, -150, -1450],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0060, 0.0060, 0.0060],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },
//    904: {
//    // overallScale: 4.717,
//     overallScale: 7.717,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.01,0.01,0.01],
//     // scale: 0.017,
//     patternScalling: 100,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -13.5, -14],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 14, 9],

//     frontNumberPosition: [0, -13.5, 1],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.1500, 0.1040, 0.0090],

//     frontLogoPosition: [0, -13.5, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0012, 0.0010, 0.0009],

//     backTextPosition: [0, 13.5, -14],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 14, 9],

//     backNumberPosition: [0, 13.5, 1],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.5000, 1.0400, 0.0900],

//     backLogoPosition: [0, 13.5, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0012, 0.0010, 0.0009],

//     logoPosition: [0, 0, 0],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   }
//   },
//   menmenjersey: {
//     overallScale: 8.417,
//     position: [0, -0.003, -0.029],
//     rotation: [0, 0, 0],
//     // scale: 9.717,
//     scale: [1.717,1.717,1.717],

//     // designposition: [0, -0.003, -0.015],
//     // designrotation:[0, 0, 0],
//     // designscale: 1.717,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     patternScalling: 0.717,

//     fontSize: 120,
//     fontSizeNumber: 40,
//     frontTextPosition: [0, 0.05, 0.1],
//     frontTextRotation: [0, 0, 0],
//     // frontTextScale: [0.1, 0.07, 0.2],
//     frontTextScale: [0.19, 0.065, 0.2],

//     frontNumberPosition: [0, -0.06, 0.1],
//     frontNumberRotation: [0, 0, 0],
//     // frontNumberScale: [0.0020, 0.0008, 0.0001],
//     frontNumberScale: [0.0002, 0.0001, 0.0002],

//     frontLogoPosition: [0.04, 0.12, 0.1],
//     frontLogoRotation: [0, 0, 0],
//     frontLogoScale: [0.0000, 0.0000, 0.0000],

//     backTextPosition: [0, 0.05, -0.1],
//     backTextRotation: [0, Math.PI, 0],
//     // backTextScale: [0.25, 0.1, 0.1],
//     backTextScale: [0.19, 0.065, 0.2],

//     backNumberPosition: [0, -0.06, -0.1],
//     backNumberRotation: [0, Math.PI, 0],
//     // backNumberScale: [0.0200, 0.0077, 0.0010],
//     backNumberScale: [0.0020, 0.0015, 0.0020],

//     backLogoPosition: [-0.04, 0.13, -0.07],
//     backLogoRotation: [0, Math.PI, 0],
//     backLogoScale: [0.0000, 0.0000, 0.0000],

//     // logoPosition:[0, 0.003, 0.029],
//     // logoRotation: [-0.109, 0, 0],
//     // logoScale: 20.717,
//     logoPosition: [0, 0.003, 0.029],
//     logoRotation: [-0.109, 0, 0],
//     logoScale: 0.017,
//   },
//   womenwomenfootballjersey: {
//     // overallScale: 115.717,
//     overallScale: 165.717,
//     position: [0, 0, 0],
//     rotation: [0, 0, 0],
//     scale: [0.05,0.05,0.05],
//     // scale: 0.07,
//     // patternScalling : 0.717,
//     frontTextPosition: [0, -0.15, 0.14],
//     frontTextRotation: [0, 0, 0],
//     frontTextScale: [0.35, 0.15, 0.1],

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     frontNumberPosition: [0, -0.02, 0.14],
//     frontNumberRotation: [0, 0, 0],
//     frontNumberScale: [0.0020, 0.0008, 0.0001],

//     frontLogoPosition: [0, 0.1, 0.15],
//     frontLogoRotation: [0, 0, 0],
//     frontLogoScale: [0.0000, 0.0000, 0.0000],

//     backTextPosition: [0, -0.15, -0.14],
//     backTextRotation: [0, Math.PI, 0],
//     backTextScale: [0.35, 0.15, 0.1],

//     backNumberPosition: [0, -0.02, -0.14],
//     backNumberRotation: [0, Math.PI, 0],
//     backNumberScale: [0.0200, 0.0077, 0.0010],

//     backLogoPosition: [0, 0.1, -0.15],
//     backLogoRotation: [0, Math.PI, 0],
//     backLogoScale: [0.0000, 0.0000, 0.0000],

//     logoPosition: [0, 0, 0.0006],
//     logoRotation: [0, 0, 0],
//     logoScale: 0.00,
//   },
//   menmencricketshorts :{
//      overallScale: 7.717,
//     // overallScale: 9.717,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     // scale: 0.017,
//      scale: [0.024,0.024,0.024],
//     patternScalling: 100,

//     partMappings: {
//       SHORT: ["LEFT LEG", "RIGHT LEG"],
//     },
//      fontSize: 120,
//     fontSizeNumber: 10,
//     frontTextPosition: [0, -7.5, 5],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 7, 10],

//     frontNumberPosition: [-5, -7, -4],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0370, 0.0060],

//     frontLogoPosition: [-7, -7.5, 5],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0005, 0.0003, 0.0007],

//     backTextPosition: [0, 7.5, 7],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 7, 10],

//     backNumberPosition: [-6, 7, -4],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.3700, 0.0600],

//     backLogoPosition: [6, 7.5, 9],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0005, 0.0003, 0.0007],

//     logoPosition: [-0.031, -0.009, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },
//   menmenshorts: {
//      overallScale: 7.717,
//     // overallScale: 9.717,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     // scale: 0.017,
//      scale: [0.024,0.024,0.024],
//     patternScalling: 100,

//     partMappings: {
//       SHORT: ["LEFT LEG", "RIGHT LEG"],
//     },
//      fontSize: 120,
//     fontSizeNumber: 10,
//     frontTextPosition: [0, -7.5, 5],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 7, 10],

//     frontNumberPosition: [-5, -7, -4],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0370, 0.0060],

//     frontLogoPosition: [-7, -7.5, 5],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0005, 0.0003, 0.0007],

//     backTextPosition: [0, 7.5, 7],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 7, 10],

//     backNumberPosition: [-6, 7, -4],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.3700, 0.0600],

//     backLogoPosition: [6, 7.5, 9],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0005, 0.0003, 0.0007],

//     logoPosition: [-0.031, -0.009, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },
//   womenwomenbadmintonshorts: {
//     // overallScale: 16.717,
//     overallScale: 20.717, //not working logo
//     position: [0.003, 0.01, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.009, 0.009, 0.009],
//     // scale: 0.014,
//     // patternScalling : 100,
//     partMappings: {
//       TEE: ["LEFT LEG", "RIGHT LEG"],
//     },

//     fontSize: 120,
//     fontSizeNumber: 10,
//     frontTextPosition: [0, -7.5, 4],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 7, 10],

//     frontNumberPosition: [-5, -7.2, -4],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0370, 0.0060],

//     frontLogoPosition: [-5.5, -7.5, 5],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0004, 0.0003, 0.0007],

//     backTextPosition: [0, 7.5, 4],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 7, 10],

//     backNumberPosition: [-6, 7, -4],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.3700, 0.0600],

//     backLogoPosition: [4, 7.5, 6],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0004, 0.0003, 0.0007],

//     logoPosition: [0.002, 0.095, -0.0348],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: [0.0001, 0.0001, 0.0001],
//   },
//   womenwomentrackpants: {
//     overallScale: 12,
//     position: [-0.003, 0.001, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.008,0.008,0.008],
//     // scale: 0.01,
//     patternScalling: 100,
//     partMappings: {
//       TEE: ["LEFT LEG", "RIGHT LEG"],
//     },

//       fontSize: 120,
//     fontSizeNumber: 10,
//     frontTextPosition: [0, -8, 20],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 7, 10],

//     frontNumberPosition: [-5, -8, 10],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0600, 0.0570, 0.0160],

//     frontLogoPosition: [-5, -8, 23],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0004, 0.0003, 0.0007],

//     backTextPosition: [0, 8, 20],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 7, 10],

//     backNumberPosition: [-5, 8, 10],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.6000, 0.5700, 0.1600],

//     backLogoPosition: [5, 8, 23],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0004, 0.0003, 0.0007],

//     logoPosition: [0.002, 0.235, -0.033],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: [0.0001, 0.0001, 0.0001],
//   },
//   womenwomencyclingjersey: {
//     overallScale: 6,
//     position: [0, -0.003, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.01,0.01,0.01],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//  fontSize: 120,
//      fontSizeNumber: 30,
//     frontTextPosition: [0, -15, 6],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 20, 20],

//     frontNumberPosition: [0, -15, -6],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0200, 0.0200],

//     frontLogoPosition: [8, -13, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0008, 0.0008],

//     backTextPosition: [0, 15, 6],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 20, 20],

//     backNumberPosition: [0, 15, -6],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.2000, 0.2000],

//     backLogoPosition: [8, 13, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0008, 0.0008],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },
//   menmentanktop: {
//     // overallScale: 4.717,
//     overallScale: 7.717,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.01,0.01,0.01],
//     // scale: 0.017,
//     patternScalling: 100,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -13.5, -14],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 14, 9],

//     frontNumberPosition: [0, -13.5, 1],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.1500, 0.1040, 0.0090],

//     frontLogoPosition: [0, -13.5, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0012, 0.0010, 0.0009],

//     backTextPosition: [0, 13.5, -14],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 14, 9],

//     backNumberPosition: [0, 13.5, 1],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.5000, 1.0400, 0.0900],

//     backLogoPosition: [0, 13.5, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0012, 0.0010, 0.0009],

//     logoPosition: [0, 0, 0],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },
//   menmencyclingjersey: {
//     overallScale: 7.8,
//     position: [0, 0, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: [0.001,0.001,0.001],

//     patternScalling: 750,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//      fontSize: 120,
//     fontSizeNumber: 10,
    
//     frontTextPosition: [0, 137, 133],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [320, 160, 150],

//     frontNumberPosition: [0, 137, 33],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.9200, 0.4600, 0.4300],

//     frontLogoPosition: [60, 107, -140],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0070, 0.0050, 0.0050],

//     backTextPosition: [0, -137, 133],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [320, 160, 150],

//     backNumberPosition: [0, -137, 33],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [9.2000, 4.6000, 4.3000],

//     backLogoPosition: [-60, -137, -140],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0070, 0.0050, 0.0050],

//     // logoPosition: [0, 0.003, 0.038],
//     logoPosition: [0, 0.003, 0.029],
//     logoRotation: [-0.109, 0, 0],
//     logoScale: 0.017,
//   },
//   menmentrackpants: {
//     // overallScale: 4.1,
//     overallScale: 5.8,
//     position: [0, -0.04, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.016,0.016,0.016],
//     // scale: 0.025,
//     patternScalling: 100,
//     partMappings: {
//       SHORT: ["LEFT LEG", "RIGHT LEG"],
//     },
//        fontSize: 120,
//     fontSizeNumber: 20,
//     frontTextPosition: [0, -10, 20],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 10, 10],

//     frontNumberPosition: [-5, -6, 10],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0500, 0.0250, 0.0250],

//     frontLogoPosition: [5, -6, 10],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0003, 0.0003, 0.0010],

//     backTextPosition: [0, 10, 25],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 10, 10],

//     backNumberPosition: [-5, 6, 10],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.5000, 0.2500, 0.2500],

//     backLogoPosition: [5, 6, 10],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0003, 0.0003, 0.0010],

//     logoPosition: [-0.037, -0.045, 0.011],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },
//   menmencricketjersey: {
//      overallScale: 8.417,
//     position: [0, -0.003, -0.029],
//     rotation: [0, 0, 0],
//     // scale: 9.717,
//     scale: [1.717,1.717,1.717],

//     // designposition: [0, -0.003, -0.015],
//     // designrotation:[0, 0, 0],
//     // designscale: 1.717,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     patternScalling: 0.717,

//     fontSize: 120,
//     fontSizeNumber: 40,
//     frontTextPosition: [0, 0.05, 0.1],
//     frontTextRotation: [0, 0, 0],
//     // frontTextScale: [0.1, 0.07, 0.2],
//     frontTextScale: [0.19, 0.065, 0.2],

//     frontNumberPosition: [0, -0.06, 0.1],
//     frontNumberRotation: [0, 0, 0],
//     // frontNumberScale: [0.0020, 0.0008, 0.0001],
//     frontNumberScale: [0.0002, 0.0001, 0.0002],

//     frontLogoPosition: [0.04, 0.12, 0.1],
//     frontLogoRotation: [0,0, 0],
//     frontLogoScale: [0.0000, 0.0000, 0.0000],

//     backTextPosition: [0, 0.05, -0.1],
//     backTextRotation: [0, Math.PI, 0],
//     // backTextScale: [0.25, 0.1, 0.1],
//     backTextScale: [0.19, 0.065, 0.2],

//     backNumberPosition: [0, -0.06, -0.1],
//     backNumberRotation: [0, Math.PI, 0],
//     // backNumberScale: [0.0200, 0.0077, 0.0010],
//     backNumberScale: [0.0020, 0.0015, 0.0020],

//     backLogoPosition: [-0.04, 0.13, -0.07],
//     backLogoRotation: [0, Math.PI, 0],
//     backLogoScale: [0.0000, 0.0000, 0.0000],

//     // logoPosition:[0, 0.003, 0.029],
//     // logoRotation: [-0.109, 0, 0],
//     // logoScale: 20.717,
//     logoPosition: [0, 0.003, 0.029],
//     logoRotation: [-0.109, 0, 0],
//     logoScale: 0.017,
//   },

//   menmenarmsleeves: {
//     //Second glb(FullPoloM1Demo)
//     overallScale: 7.5,
//     position: [0, -1.315, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: [0.001,0.001,0.001],
//     patternScalling: 750,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     frontTextPosition: [0, 137, 133],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [320, 160, 150],

//     frontNumberPosition: [0, 137, 33],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.9200, 0.7600, 0.1500],

//     frontLogoPosition: [60, 137, -140],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0120, 0.0080, 0.0150],

//     backTextPosition: [0, -137, 133],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [320, 160, 150],

//     backNumberPosition: [0, -137, 33],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [9.2000, 7.6000, 1.5000],

//     backLogoPosition: [-60, -137, -140],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0120, 0.0080, 0.0150],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },

// //   menmenbasketballjersey: {
// //     //3rd glb(Ktrack)
// //     overallScale: 6,
// //     position: [0, -0.143, 0],
// //     rotation: [-Math.PI / 2, 0, 0],
// //     scale: 0.022,
// //     patternScalling: 750,
// //     partMappings: {
// //       TRACK: ["LEFT LEG", "RIGHT LEG"],
// //     },
// // fontSize: 470,
// //     fontSizeNumber: 30,

// //     frontTextPosition: [0, 137, 133],
// //     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
// //     frontTextScale: [990, 390, 190],

// //     frontNumberPosition: [0, 137, 33],
// //     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
// //     frontNumberScale: [0.9200, 0.7600, 0.1500],

// //     frontLogoPosition: [60, 137, -140],
// //     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
// //     frontLogoScale: [12.0000, 8.0000, 15.0000],

// //     backTextPosition: [0, -137, 133],
// //     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
// //     backTextScale: [320, 160, 150],

// //     backNumberPosition: [0, -137, 33],
// //     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
// //     backNumberScale: [9.2000, 7.6000, 1.5000],

// //     backLogoPosition: [-60, -137, -140],
// //     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
// //     backLogoScale: [12.0000, 8.0000, 15.0000],

// //     logoPosition: [0, 0, -0.005],
// //     logoRotation: [-Math.PI / 2, 0, 0],
// //     logoScale: 0.01,
// //   },

//   menmenbasketballshorts: {
//     //4th glb(Kshort)
//     overallScale: 7,
//     position: [0, 0.064, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.023,0.023,0.023],
//     patternScalling: 750,
//     partMappings: {
//       TRACK: ["RIGHT LEG", "LEFT LEG"],
//     },
// fontSize: 120,
//     fontSizeNumber: 30,
    
//     frontTextPosition: [0, 137, 133],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [320, 160, 150],

//     frontNumberPosition: [0, 137, 33],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.9200, 0.7600, 0.1500],

//     frontLogoPosition: [60, 137, -140],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0120, 0.0080, 0.0150],

//     backTextPosition: [0, -137, 133],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [320, 160, 150],

//     backNumberPosition: [0, -137, 33],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [9.2000, 7.6000, 1.5000],

//     backLogoPosition: [-60, -137, -140],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0120, 0.0080, 0.0150],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },

// womenwomenbadmintonjersey:{
//  overallScale: 6,
//     position: [0, -1.284, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: [0.001,0.001,0.001],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     fontSize: 120,
//     fontSizeNumber: 30,

//     frontTextPosition: [0, 100, -1150],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [300, 250, 200],

//     frontNumberPosition: [0, 100, -1350],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.3000, 0.2500, 0.2000],

//     frontLogoPosition:  [60, 50, -1450],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0060, 0.0060, 0.0060],

//     backTextPosition: [0, -100, -1150],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [300, 250, 200],

//     backNumberPosition: [0, -100, -1350],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [3.0000, 2.5000, 2.0000],

//     backLogoPosition: [60, -150, -1450],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0060, 0.0060, 0.0060],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
// },
//  menmensoccerjersey:{
// overallScale: 6,
//     position: [0, 0, -0.005],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: [0.001,0.001,0.001],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       // TEE: ["FRONT", "BACK"],
//       FRONT: ["FRONT"],
//       BACK: ["BACK"],
//     },
//   fontSize: 120,
//     fontSizeNumber: 20,
//     frontTextPosition: [0, 137, 133],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [320, 160, 150],

//     frontNumberPosition: [0, 137, 33],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.9200, 0.7600, 0.1500],

//     frontLogoPosition: [60, 137, -140],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0120, 0.0080, 0.0150],

//     backTextPosition: [0, -137, 133],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [320, 160, 150],

//     backNumberPosition: [0, -137, 33],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [9.2000, 7.6000, 1.5000],

//     backLogoPosition: [-60, -137, -140],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0120, 0.0080, 0.0150],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//  },

//  womenwomenjersey:{
// overallScale: 6,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.011,0.011,0.011],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//  fontSize: 120,
//      fontSizeNumber: 30,
     
//      frontTextPosition: [0, -15, 6],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 20, 20],

//     frontNumberPosition: [0, -15, -6],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0200, 0.0200],

//     frontLogoPosition: [8, -10, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0008, 0.0008],

//     backTextPosition: [0, 15, 6],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 20, 20],

//     backNumberPosition: [0, 15, -6],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.2000, 0.2000],

//     backLogoPosition: [8, 13, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0008, 0.0008],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//  },
//   menmenbasketballjersey:{
// overallScale: 6,
//     position: [0, -0.003, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.01,0.01,0.01],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//  fontSize: 120,
//      fontSizeNumber: 30,
//     frontTextPosition: [0, -15, 6],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 20, 20],

//     frontNumberPosition: [0, -15, -6],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0200, 0.0200],

//     frontLogoPosition: [8, -13, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0008, 0.0008],

//     backTextPosition: [0, 15, 6],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 20, 20],

//     backNumberPosition: [0, 15, -6],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.2000, 0.2000],

//     backLogoPosition: [8, 13, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0008, 0.0008],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//  },
//    kidskidsbasketballjersey:{
//  overallScale: 736,
//     position: [0, 0, 0],
//     rotation: [0, 0, 0],
//     scale: [0.01,0.01,0.01],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//  fontSize: 120,
//      fontSizeNumber: 30,
//     frontTextPosition: [0, -15, 6],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 20, 20],

//     frontNumberPosition: [0, -15, -6],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0400, 0.0200, 0.0200],

//     frontLogoPosition: [8, -13, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0008, 0.0008],

//     backTextPosition: [0, 15, 6],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 20, 20],

//     backNumberPosition: [0, 15, -6],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.4000, 0.2000, 0.2000],

//     backLogoPosition: [8, 13, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0008, 0.0008],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },
//   menmencitycollection:{
// overallScale: 6,
//     position: [0, -1.315, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: 0.001,
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     fontSize: 120,
//     fontSizeNumber: 30,

//      frontTextPosition: [0, 100, -1150],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [300, 250, 200],

//     frontNumberPosition: [0, 100, -1350],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.3000, 0.2500, 0.2000],

//     frontLogoPosition:  [60, 80, -1450],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0060, 0.0060, 0.0060],

//     backTextPosition: [0, -100, -1150],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [300, 250, 200],

//     backNumberPosition: [0, -100, -1350],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [3.0000, 2.5000, 2.0000],

//     backLogoPosition: [60, -150, -1450],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0060, 0.0060, 0.0060],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },
// menmenxjersey:{
// overallScale: 6,
//     position: [0, -1.315, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: 0.001,
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     fontSize: 120,
//     fontSizeNumber: 30,

//      frontTextPosition: [0, 100, -1150],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [300, 250, 200],

//     frontNumberPosition: [0, 100, -1350],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.3000, 0.2500, 0.2000],

//     frontLogoPosition:  [60, 80, -1450],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0060, 0.0060, 0.0060],

//     backTextPosition: [0, -100, -1150],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [300, 250, 200],

//     backNumberPosition: [0, -100, -1350],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [3.0000, 2.5000, 2.0000],

//     backLogoPosition: [60, -150, -1450],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0060, 0.0060, 0.0060],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
// },
//   kidskidscricketshorts: {
//     overallScale: 13,
//     position: [0, -0.043, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.022,0.022,0.022],
//     patternScalling: 750,

//     partMappings: {
//       TRACK: ["LEFT LEG", "RIGHT LEG"],
//     },
//  fontSize: 120,
//     fontSizeNumber: 30,

//    frontTextPosition: [0, -4.5, 2],
//     frontTextScale: [15, 5, 5],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],

//     frontNumberPosition: [-3, -4.5, -3],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0070, 0.0050, 0.0050],

//     frontLogoPosition: [3, -4, -3],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0002, 0.0002, 0.0002],

//     backTextPosition: [0, 4.5, 2],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [15, 5, 5],

//     backNumberPosition: [-3, 4.5, -3],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.0700, 0.0500, 0.0500],

//     backLogoPosition: [3, 4, -3],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0002, 0.0002, 0.0002],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },

//   kidskidsshorts: {
//     overallScale: 6,
//     position: [0, -0.143, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.022,0.022,0.022],
//     patternScalling: 750,
//     partMappings: {
//       TRACK: ["LEFT LEG", "RIGHT LEG"],
//     },
//  fontSize: 100,
//     fontSizeNumber: 30,
//    frontTextPosition: [0, -5, 10],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 10, 10],

//     frontNumberPosition: [-3.5, -5, 5],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0100, 0.0100, 0.0100],

//     frontLogoPosition: [4, -3, 3],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0003, 0.0003, 0.0002],

//     backTextPosition: [0, 5, 10],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 10, 10],

//     backNumberPosition: [-3.5, 5, 5],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.1000, 0.1000, 0.1000],

//     backLogoPosition: [4, 3, 3],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0003, 0.0003, 0.0002],

//     logoPosition: [-0.037, -0.045, 0.011],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },

//    kidskidstrackpants: {
//     overallScale: 6,
//     position: [0, -0.143, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.022,0.022,0.022],
//     patternScalling: 750,
//     partMappings: {
//       TRACK: ["LEFT LEG", "RIGHT LEG"],
//     },
//  fontSize: 100,
//     fontSizeNumber: 30,
//    frontTextPosition: [0, -5, 10],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [20, 10, 10],

//     frontNumberPosition: [-3.5, -5, 5],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0100, 0.0100, 0.0100],

//     frontLogoPosition: [4, -3, 3],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0003, 0.0003, 0.0002],

//     backTextPosition: [0, 5, 10],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 10, 10],

//     backNumberPosition: [-3.5, 5, 5],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.1000, 0.1000, 0.1000],

//     backLogoPosition: [4, 3, 3],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0003, 0.0003, 0.0002],

//     logoPosition: [-0.037, -0.045, 0.011],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },

//   menmenfootballjersey: {
//     //First glb(ZipperM)
//     // overallScale: 6.5,
//     // position: [0, 0, 0],
//     // rotation: [-Math.PI / 2, 0, 0],
//     // scale: 0.01,
//     // patternScalling: 750,
//     // partMappings: {
//     //   LEFTSLEVE: ["LEFT SLEEVE"],
//     //   RIGHTSLEVE: ["RIGHT SLEEVE"],
//     //   TEE: ["FRONT", "BACK"],
//     // },

//     //Second glb(FullPoloM1Demo)
//     overallScale: 7.5,
//     position: [0, -1.315, 0],
//     rotation: [Math.PI / 2, 0, 0],
//     scale: [0.001,0.001,0.001],
//     patternScalling: 750,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//     //3rd glb(Ktrack)
//     //  overallScale: 6,
//     //  position: [0, -0.143, 0],
//     //  rotation: [-Math.PI / 2, 0, 0],
//     //  scale: 0.022,
//     //  patternScalling: 750,
//     //  partMappings: {
//     //    TRACK: ["FRONT", "BACK"],
//     //  },

//     //4th glb(Kshort)
//     //  overallScale: 7,
//     //  position: [0, 0.064, 0],
//     //  rotation: [-Math.PI / 2, 0, 0],
//     //  scale: 0.023,
//     //  patternScalling: 750,
//     //  partMappings: {
//     //    TRACK: ["FRONT", "BACK"],
//     //  },

//     frontTextPosition: [0, 137, 133],
//     frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontTextScale: [320, 160, 150],

//     frontNumberPosition: [0, 137, 33],
//     frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontNumberScale: [0.9200, 0.7600, 0.1500],

//     frontLogoPosition: [60, 137, -140],
//     frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
//     frontLogoScale: [0.0120, 0.0080, 0.0150],

//     backTextPosition: [0, -137, 133],
//     backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backTextScale: [320, 160, 150],

//     backNumberPosition: [0, -137, 33],
//     backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backNumberScale: [9.2000, 7.6000, 1.5000],

//     backLogoPosition: [-60, -137, -140],
//     backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//     backLogoScale: [0.0120, 0.0080, 0.0150],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },

//   womenwomencricketjersey: {
//     overallScale: 8,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.012,0.012,0.012],
//     // scale: 0.016,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     patternScalling: 100,
//     frontTextPosition: [0, -13.5, -14],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [30, 14, 9],

//     frontNumberPosition: [0, -13.5, 1],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.1300, 0.0800, 0.0090],

//     frontLogoPosition: [5, -9.5, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0007, 0.0009],

//     backTextPosition: [0, 13.5, -14],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 14, 9],

//     backNumberPosition: [0, 13.5, 1],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.5000, 1.0400, 0.0900],

//     backLogoPosition: [-5, 9.5, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0007, 0.0009],

//     logoPosition: [0, 0, 0.008],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },
//   womenwomenbadmintontanktop: {
//     overallScale: 8,
//     position: [0, 0, 0],
//     rotation: [0, 0, 0],
//     scale: [2.076,2.076,2.076],

//     // scale: 2.776,

//     partMappings: {
//       SLEVES: ["LEFT SIDE PANEL", "RIGHT SIDE PANEL"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     patternScalling: 1,
//     frontTextPosition: [0, -0.07, 0.075],
//     frontTextRotation: [0, 0, 0],
//     frontTextScale: [0.2, 0.1, 0.1],

//     frontNumberPosition: [0, 0, 0.075],
//     frontNumberRotation: [0, 0, 0],
//     frontNumberScale: [0.0006, 0.0004, 0.0001],

//     frontLogoPosition: [0.04, 0.06, 0.075],
//     frontLogoRotation: [0, 0, 0],
//     frontLogoScale: [0.0000, 0.0000, 0.0000],

//     backTextPosition: [0, -0.07, -0.075],
//     backTextRotation: [0, Math.PI, 0],
//     backTextScale: [0.2, 0.1, 0.1],

//     backNumberPosition: [0, 0, -0.075],
//     backNumberRotation: [0, Math.PI, 0],
//     backNumberScale: [0.0060, 0.0040, 0.0010],

//     backLogoPosition: [-0.04, 0.06, -0.075],
//     backLogoRotation: [0, Math.PI, 0],
//     backLogoScale: [0.0000, 0.0000, 0.0000],

//     logoPosition: [0, 0, 0.006],
//     logoRotation: [0, 0, 0],
//     logoScale: 0.021,
//   },
//   womenwomenxjersey: {
//     overallScale: 218.717,
//     position: [0, 0, 0],
//     rotation: [0, 0, 0],
//     scale: [0.04, 0.04, 0.04],
//     // scale: 0.055,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -0.15, 0.17],
//     frontTextRotation: [0, 0, 0],
//     frontTextScale: [0.35, 0.15, 0.1],
//     patternScalling: 100,
//     frontNumberPosition: [0, -0.02, 0.18],
//     frontNumberRotation: [0, 0, 0],
//     frontNumberScale: [0.0020, 0.0008, 0.0001],

//     frontLogoPosition: [0.07, 0.15, 0.16],
//     frontLogoRotation: [0, 0, 0],
//     frontLogoScale: [0.0000, 0.0000, 0.0000],

//     backTextPosition: [0, -0.15, -0.12],
//     backTextRotation: [0, Math.PI, 0],
//     backTextScale: [0.35, 0.15, 0.1],

//     backNumberPosition: [0, -0.02, -0.11],
//     backNumberRotation: [0, Math.PI, 0],
//     backNumberScale: [0.0200, 0.0077, 0.0010],

//     backLogoPosition: [-0.07, 0.15, -0.105],
//     backLogoRotation: [0, Math.PI, 0],
//     backLogoScale: [0.0000, 0.0000, 0.0000],

//     logoPosition: [0, 0, 0.00035],
//     logoRotation: [0, 0, 0],
//     logoScale: 0.00,
//   },
//   kidskidscricketjersey: {
//     overallScale: 9.917,
//     position: [0, -0.001, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.011, 0.012, 0.012],
//     // scale: [0.0165, 0.0165, 0.0165],
//     patternScalling: 100,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//       fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -8.5, -10],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [30, 14, 9],

//     frontNumberPosition: [0, -8.5, 1],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.1500, 0.1040, 0.0090],

//     frontLogoPosition: [5, -8.5, 14],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0007, 0.0009],

//     backTextPosition: [0, 8.5, -10],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 14, 9],

//     backNumberPosition: [0, 8.5, 1],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.5000, 1.0400, 0.0900],

//     backLogoPosition: [-5, 10.5, 14],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0007, 0.0009],

//     logoPosition: [0, 0, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: [0.0001, 0.0001, 0.0001],
//   },
//   // menfootballjersey: {
//   //   overallScale: 5.717,
//   //   position: [0.001, -0.001, 0],
//   //   rotation: [Math.PI / 2, 0, 0],
//   //   scale: 0.005,
//   //   patternScalling: 100,
//   //   partMappings: {
//   //     LEFTSLEVE: ["LEFT SLEEVE"],
//   //     RIGHTSLEVE: ["RIGHT SLEEVE"],
//   //     TEE: ["FRONT", "BACK"],
//   //   },
//   //   frontTextPosition: [0, 145, 8],
//   //   frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
//   //   frontTextScale: [340, 220, 110],

//   //   backTextPosition: [0, -145, 8],
//   //   backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
//   //   backTextScale: [340, 220, 110],
//   // },
//   kidskidscyclingjersey: {
//     overallScale: 9.717,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.03,0.03,0.03],
//     // scale: 0.045,
//     patternScalling: 70,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//       fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -3.5, -5],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [8, 6, 3],

//     frontNumberPosition: [0, -3.5, 0],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0380, 0.0260, 0.0130],

//     frontLogoPosition: [1.9, -3, 4.5],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0004, 0.0003, 0.0003],

//     backTextPosition: [0, 3.5, -5],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [8, 6, 3],

//     backNumberPosition: [0, 4, 0],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.3800, 0.2600, 0.1300],

//     backLogoPosition: [-1.9, 5, 4.5],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0004, 0.0003, 0.0003],

//     logoPosition: [0, 0, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.00,
//   },
//   kidskidsjersey: {
//     overallScale: 9.717,
//     position: [0.002, 0.007, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.029,0.029,0.029],
//     // scale: 0.04,
//     patternScalling: 70,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//     frontTextPosition: [0, -3.5, -5],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [8, 6, 3],

//     frontNumberPosition: [0, -4.9, -0.5],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0380, 0.0260, 0.0130],

//     frontLogoPosition: [1.9, -3, 4.5],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0004, 0.0003, 0.0003],

//     backTextPosition: [0, 3.5, -5],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [8, 6, 3],

//     backNumberPosition: [0, 4, 0],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.3800, 0.2600, 0.1300],

//     backLogoPosition: [-1.9, 3, 4.5],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0004, 0.0003, 0.0003],

//     logoPosition: [0.002, 0.007, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },
//   kidskidstanktop: {
//     overallScale: 13.417,
//     position: [0, -0.008, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.005, 0.007, 0.006],
//     // scale: [0.0075, 0.0085, 0.0075],
//     patternScalling: 100,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//      fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -12, -13],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [30, 10, 15],

//     frontNumberPosition: [0, -11, 6],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.1600, 0.0700, 0.0100],

//     frontLogoPosition: [5, -9, 22],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0008, 0.0010],

//     backTextPosition: [0, 12, -13],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [20, 10, 10],

//     backNumberPosition: [0, 11, 6],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.6000, 0.7000, 0.1000],

//     backLogoPosition: [5, 14, 22],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0008, 0.0010],

//     logoPosition: [0, -0.008, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: [0.0001, 0.0001, 0.0001],
//   },

//   kidskidsbasictshirt: {
//     overallScale: 8.717,
//     position: [-0.002, -1.1, -0.007],
//     rotation: [-Math.PI / 2, 0, 0],
//     // position: [-0.002, -1.55, -0.007],
//     // rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.027,0.027,0.027],
//     // scale: 0.04,
//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },

//        fontSize: 120,
//     fontSizeNumber: 10,

//     patternScalling: 100,
//     frontTextPosition: [0, -5, 33],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [10, 5, 5],

//     frontNumberPosition: [0, -4.5, 39],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.0600, 0.0350, 0.0050],

//     frontLogoPosition: [3, -4, 44],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0003, 0.0003, 0.0005],

//     backTextPosition: [0, 5, 33],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [10, 5, 5],

//     backNumberPosition: [0, 4.5, 39],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [0.6000, 0.3500, 0.0500],

//     backLogoPosition: [-3, 4.5, 44],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0003, 0.0003, 0.0005],

//     logoPosition: [0, -0.06, 0.01],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.000,
//   },
//   womenwomencompressionpants: {
//     overallScale: 11.717,
//     position: [0, -0.05, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.005,0.005,0.005],
//     // scale: 0.0055,
//     partMappings: {
//       TEE: ["LEFT LEG", "RIGHT LEG"],
//     },
//      fontSize: 120,
//     fontSizeNumber: 10,

//     frontTextPosition: [0, -12, 39],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 16, 15],

//     frontNumberPosition: [-10, -11, 26],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [0.1600, 0.0900, 0.0100],

//     frontLogoPosition: [10, -11, 20],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [0.0008, 0.0008, 0.0010],

//     backTextPosition: [0, 12, 39],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 16, 15],

//     backNumberPosition: [10, 11, 19],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [1.6000, 0.9000, 0.1000],

//     backLogoPosition: [-10, 10, 20],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [0.0008, 0.0008, 0.0010],

//     logoPosition: [0.002, 0.21, -0.034],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: [0.0001, 0.0001, 0.0001],
//   },
// };

// export default modelConfig1;


const modelConfig1 = {
  eventordereventjersey:{
    900: {
    overallScale: 9.917,
    position: [0, -0.001, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.011, 0.012, 0.012],
    // scale: [0.0165, 0.0165, 0.0165],
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

      fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -8.5, -10],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 14, 9],

    frontNumberPosition: [0, -8.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [150, 104, 9],

    frontLogoPosition: [5, -8.5, 14],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 7, 9],

    backTextPosition: [0, 8.5, -10],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 8.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [-5, 10.5, 14],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 7, 9],

    logoPosition: [0, 0, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.011, 0.012, 0.012],
  },
   901: {
    overallScale: 7.8,
    position: [0, 0, 0],
    rotation: [Math.PI / 2, 0, 0],
    scale: [0.001,0.001,0.001],

    patternScalling: 750,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    
    frontTextPosition: [0, 137, 133],
    frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
    frontTextScale: [320, 160, 150],

    frontNumberPosition: [0, 137, 33],
    frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
    frontNumberScale: [920, 460, 430],

    frontLogoPosition: [60, 107, -140],
    frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
    frontLogoScale: [70, 50, 50],

    backTextPosition: [0, -137, 133],
    backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backTextScale: [320, 160, 150],

    backNumberPosition: [0, -137, 33],
    backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backNumberScale:  [920, 460, 430],

    backLogoPosition: [-60, -137, -140],
    backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backLogoScale: [70, 50, 50],

    // logoPosition: [0, 0.003, 0.038],
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
  },
 902: {
   overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
  },
   903: {
   overallScale: 6,
    position: [0, -1.315, 0],
    rotation: [Math.PI / 2, 0, 0],
    scale: 0.001,
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    fontSize: 120,
    fontSizeNumber: 270,

     frontTextPosition: [0, 100, -1150],
    frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
    frontTextScale: [300, 250, 200],

    frontNumberPosition: [0, 100, -1350],
    frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
    frontNumberScale: [300, 250, 200],

    frontLogoPosition:  [60, 80, -1450],
    frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
    frontLogoScale: [60, 60, 60],

    backTextPosition: [0, -100, -1150],
    backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backTextScale: [300, 250, 200],

    backNumberPosition: [0, -100, -1350],
    backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backNumberScale: [300, 250, 200],

    backLogoPosition: [60, -150, -1450],
    backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backLogoScale: [60, 60, 60],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   904: {
   // overallScale: 4.717,
    overallScale: 7.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    // scale: 0.017,
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 120,

    frontTextPosition: [0, -13.5, -14],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 14, 9],

    frontNumberPosition: [0, -13.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [150, 104, 9],

    frontLogoPosition: [0, -13.5, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [12, 10, 9],

    backTextPosition: [0, 13.5, -14],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 13.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [0, 13.5, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [12, 10, 9],

    logoPosition: [0, 0, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  }
  },
  menmennftfootballjersey:{
    overallScale:8,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: 0.008,

        partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 340,

    frontTextPosition: [0, -15, -20],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI , Math.PI ],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, 5],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI , Math.PI ],
    frontNumberScale: [50, 20, 20],

    frontLogoPosition: [5, -12, 22],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI , Math.PI ],
    frontLogoScale: [12, 12, 12],

    backTextPosition: [0, 15, -20],
    backTextRotation: [(3 * Math.PI) / 2, 0 , Math.PI ],
    backTextScale: [40, 20, 20],

    backNumberPosition:  [0, 15, 5],
    backNumberRotation: [(3 * Math.PI) / 2, 0 , Math.PI ],
    backNumberScale: [50, 20, 20],

    backLogoPosition: [-5, 12, 22],
    backLogoRotation: [(3 * Math.PI) / 2, 0 , Math.PI ],
    backLogoScale: [12, 12, 12],

    logoPosition:[0, 0, 0],
    logoRotation:[-Math.PI / 2, 0, 0],
    logoScale:[0.008, 0.008, 0.008],
  },
  menmenjersey: {
    overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 0.017,
  },  
  menmenxjersey:{
     overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
   },
  menmenprotshirt: {
    overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
  },
  womenwomenfootballjersey: {
    // overallScale: 115.717,
    overallScale: 165.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.05,0.05,0.05],
    // scale: 0.07,
    // patternScalling : 0.717,
    frontTextPosition: [0, -0.15, 0.14],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontNumberPosition: [0, -0.02, 0.14],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0, 0.1, 0.15],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.14],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.14],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [0, 0.1, -0.15],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.0006],
    logoRotation: [0, 0, 0],
    logoScale: 0.05,
  },
  womenwomenjersey:{
  overallScale: 165.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.05,0.05,0.05],
    // scale: 0.07,
    // patternScalling : 0.717,
    frontTextPosition: [0, -0.15, 0.14],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontNumberPosition: [0, -0.02, 0.14],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0, 0.1, 0.15],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.14],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.14],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [0, 0.1, -0.15],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.0006],
    logoRotation: [0, 0, 0],
    logoScale: 0.05,
  },
  menmencricketshorts :{
    overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmencyclingshorts: {
     overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmenrunningshorts: {  
     overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
   menmenwovenshorts: {  
     overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmenknittedshorts: {  
    overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmenfootballshorts: {  
    overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmensoccershorts: {  
   overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmenshorts: {
    overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmenbasketballshorts: {
    overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  menmennftfootballshorts: {
    overallScale: 8.717,
    // overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    // scale: 0.017,
     scale: [0.017,0.017,0.017],
    patternScalling: 100,

    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    frontTextPosition: [0, -7.5, 5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-7, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [5, 3, 7],

    backTextPosition: [0, 7.5, 7],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [6, 7.5, 9],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [5, 3, 7],

    logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,
  },
  womenwomenbadmintonshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.235, -0.037],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
   womenwomencyclingshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

     logoPosition: [-0.031, -0.008, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.017,

    // logoPosition: [0.002, 0.095, -0.0348],
    // logoRotation: [-Math.PI / 2, 0, 0],
    // logoScale: [0.005, 0.005, 0.006],
  },
   womenwomencricketshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
   womenwomenwovenshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
     womenwomentightshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
     womenwomenfootballshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
   womenwomensoccershorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
     womenwomennftfootballshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },

     womenwomenbasketballshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
  womenwomenknittedshorts: {
     // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
   womenwomenshorts: {
    // overallScale: 16.717,
    overallScale: 20.717, //not working logo
    position: [0.003, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.009, 0.009, 0.009],
    // scale: 0.014,
    // patternScalling : 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

    fontSize: 120,
    fontSizeNumber: 80,
    frontTextPosition: [0, -7.5, 4],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -7.2, -4],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 37, 6],

    frontLogoPosition: [-5.5, -7.5, 5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 7.5, 4],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-6, 7, -4],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 37, 6],

    backLogoPosition: [4, 7.5, 6],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.095, -0.0348],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
  womenwomencitycollection:{
    overallScale: 6,
    position: [0, -1.284, 0],
    rotation: [Math.PI / 2, 0, 0],
    scale: [0.001,0.001,0.001],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    fontSize: 120,
    fontSizeNumber: 270,

    frontTextPosition: [0, 100, -1150],
    frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
    frontTextScale: [300, 250, 200],

    frontNumberPosition: [0, 100, -1350],
    frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
    frontNumberScale: [300, 250, 200],

    frontLogoPosition:  [60, 50, -1450],
    frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
    frontLogoScale: [60, 60, 60],

    backTextPosition: [0, -100, -1150],
    backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backTextScale: [300, 250, 200],

    backNumberPosition: [0, -100, -1350],
    backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backNumberScale: [300, 250, 200],

    backLogoPosition: [60, -150, -1450],
    backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backLogoScale: [60, 60, 60],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  menmensoccerjersey:{
  overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
 },

  menmencricketjersey: {
   overallScale: 6,
    position: [0, 0, -0.005],
    rotation: [Math.PI / 2, 0, 0],
    scale: [0.001,0.001,0.001],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      // TEE: ["FRONT", "BACK"],
      FRONT: ["FRONT"],
      BACK: ["BACK"],
    },
  fontSize: 120,
    fontSizeNumber: 170,
    frontTextPosition: [0, 167, 133],
    frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
    frontTextScale: [320, 160, 150],

    frontNumberPosition: [0, 147, 73],
    frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
    frontNumberScale: [920, 760, 150],

    frontLogoPosition: [60, 167, -140],
    frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
    frontLogoScale: [120, 80, 150],

    backTextPosition: [0, -137, 133],
    backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backTextScale: [320, 160, 150],

    backNumberPosition: [0, -137, 33],
    backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backNumberScale: [920, 760, 150],

    backLogoPosition: [-60, -137, -140],
    backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backLogoScale: [120, 80, 150],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },

  womenwomentrackpants: {
    overallScale: 12,
    position: [-0.003, 0.001, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.008,0.008,0.008],
    // scale: 0.01,
    patternScalling: 100,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },

      fontSize: 120,
    fontSizeNumber: 100,
    frontTextPosition: [0, -8, 20],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 7, 10],

    frontNumberPosition: [-5, -8, 10],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [60, 57, 16],

    frontLogoPosition: [-5, -8, 23],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 3, 7],

    backTextPosition: [0, 8, 20],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 7, 10],

    backNumberPosition: [-5, 8, 10],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [60, 57, 16],

    backLogoPosition: [5, 8, 23],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 3, 7],

    logoPosition: [0.002, 0.235, -0.033],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
  womenwomencrickettrackpants:{
     overallScale: 17.717,
    position: [0, -0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.005,0.005,0.005],
    // scale: 0.0055,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -10, 19],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 16, 15],

    frontNumberPosition: [-10, -11, 26],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [160, 90, 10],

    frontLogoPosition: [10, -11, 20],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 8, 10],

    backTextPosition: [0, 12, 39],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 16, 15],

    backNumberPosition: [10, 11, 19],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [160, 90, 10],

    backLogoPosition: [-10, 10, 20],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 8, 10],

    logoPosition: [0.002, 0.21, -0.034],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
  womenwomencyclingjersey: {
   overallScale: 6,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.011,0.011,0.011],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
     
     frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -10, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   womenwomenracefitjersey: {
   overallScale: 6,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.011,0.011,0.011],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
     
     frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -10, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   womenwomenwinterjersey: {
   overallScale: 6,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.011,0.011,0.011],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
     
     frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -10, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  menmentanktop: {
    // overallScale: 4.717,
    overallScale: 7.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    // scale: 0.017,
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 120,

    frontTextPosition: [0, -13.5, -14],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 14, 9],

    frontNumberPosition: [0, -13.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [150, 104, 9],

    frontLogoPosition: [0, -13.5, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [12, 10, 9],

    backTextPosition: [0, 13.5, -14],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 13.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [0, 13.5, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [12, 10, 9],

    logoPosition: [0, 0, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
    menmenarmsleeves: {
   overallScale: 6,
    position: [0, -0.003, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
    frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -13, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
    menjersey: {
    // overallScale: 4.717,
    overallScale: 7.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    // scale: 0.017,
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 120,

    frontTextPosition: [0, -13.5, -14],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 14, 9],

    frontNumberPosition: [0, -13.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [150, 104, 9],

    frontLogoPosition: [0, -13.5, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [12, 10, 9],

    backTextPosition: [0, 13.5, -14],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 13.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [0, 13.5, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [12, 10, 9],

    logoPosition: [0, 0, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   menmensinglet: {
    // overallScale: 4.717,
    overallScale: 7.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    // scale: 0.017,
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 120,

    frontTextPosition: [0, -13.5, -14],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 14, 9],

    frontNumberPosition: [0, -13.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [150, 104, 9],

    frontLogoPosition: [0, -13.5, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [12, 10, 9],

    backTextPosition: [0, 13.5, -14],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 13.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [0, 13.5, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [12, 10, 9],

    logoPosition: [0, 0, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  menmencyclingjersey: {
   overallScale: 8,
    position: [0, -0.003, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
    frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 35],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 40],

    frontLogoPosition: [8, -13, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  menmenracefitjersey: {
      overallScale: 6,
    position: [0, -0.003, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
    frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -13, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  menmenwinterjersey: {
     overallScale: 6,
    position: [0, -0.003, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
    frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -13, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  menmentrackpants: {
    // overallScale: 4.1,
    overallScale: 5.8,
    position: [0, -0.04, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.016,0.016,0.016],
    // scale: 0.025,
    patternScalling: 100,
    partMappings: {
      SHORT: ["LEFT LEG", "RIGHT LEG"],
    },
       fontSize: 120,
    fontSizeNumber: 170,
    frontTextPosition: [0, -10, 20],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-5, -6, 10],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [50, 25, 25],

    frontLogoPosition: [5, -6, 10],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3, 3,10],

    backTextPosition: [0, 10, 25],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-5, 6, 10],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [50, 25, 25],

    backLogoPosition: [5, 6, 10],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3, 3, 10],

    logoPosition: [-0.037, -0.045, 0.011],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.016,
  },
  menmenbasictshirt: {
       overallScale: 7.8,
    position: [0, 0, 0],
    rotation: [Math.PI / 2, 0, 0],
    scale: [0.001,0.001,0.001],

    patternScalling: 750,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
     fontSize: 120,
    fontSizeNumber: 120,
    
    frontTextPosition: [0, 137, 133],
    frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
    frontTextScale: [320, 160, 150],

    frontNumberPosition: [0, 137, 33],
    frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
    frontNumberScale: [920, 460, 430],

    frontLogoPosition: [60, 107, -140],
    frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
    frontLogoScale: [70, 50, 50],

    backTextPosition: [0, -137, 133],
    backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backTextScale: [320, 160, 150],

    backNumberPosition: [0, -137, 33],
    backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backNumberScale:  [920, 460, 430],

    backLogoPosition: [-60, -137, -140],
    backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backLogoScale: [70, 50, 50],

    // logoPosition: [0, 0.003, 0.038],
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
  },

  menmenbasketballjersey: {
    overallScale: 6,
    position: [0, -0.003, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.01,0.01,0.01],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
    frontTextPosition: [0, -15, 6],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 20, 20],

    frontNumberPosition: [0, -15, -6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [40, 20, 20],

    frontLogoPosition: [8, -13, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [7.5, 7.5, 7.5],

    backTextPosition: [0, 15, 6],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 20, 20],

    backNumberPosition: [0, 15, -6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [40, 20, 20],

    backLogoPosition: [8, 13, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [7.5, 7.5, 7.5],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },

womenwomenbadmintonjersey:{
// overallScale: 115.717,
    overallScale: 165.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.05,0.05,0.05],
    // scale: 0.07,
    // patternScalling : 0.717,
    frontTextPosition: [0, -0.15, 0.14],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontNumberPosition: [0, -0.02, 0.14],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0, 0.1, 0.15],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.14],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.14],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [0, 0.1, -0.15],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.0006],
    logoRotation: [0, 0, 0],
    logoScale: 0.05,
},
womenwomensoccerjersey:{
// overallScale: 115.717,
    overallScale: 165.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.05,0.05,0.05],
    // scale: 0.07,
    // patternScalling : 0.717,
    frontTextPosition: [0, -0.15, 0.14],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontNumberPosition: [0, -0.02, 0.14],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0, 0.1, 0.15],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.14],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.14],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [0, 0.1, -0.15],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.0006],
    logoRotation: [0, 0, 0],
    logoScale: 0.05,
},
womenwomenprotshirt:{
   overallScale: 165.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.05,0.05,0.05],
    // scale: 0.07,
    // patternScalling : 0.717,
    frontTextPosition: [0, -0.15, 0.14],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontNumberPosition: [0, -0.02, 0.14],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0, 0.1, 0.15],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.14],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.14],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [0, 0.1, -0.15],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.0006],
    logoRotation: [0, 0, 0],
    logoScale: 0.05,
},

//  womenwomenjersey:{
// overallScale: 6,
//     position: [0, 0, 0],
//     rotation: [-Math.PI / 2, 0, 0],
//     scale: [0.011,0.011,0.011],
//     patternScalling: 750,

//     partMappings: {
//       LEFTSLEVE: ["LEFT SLEEVE"],
//       RIGHTSLEVE: ["RIGHT SLEEVE"],
//       TEE: ["FRONT", "BACK"],
//     },
//  fontSize: 120,
//      fontSizeNumber: 270,
     
//      frontTextPosition: [0, -15, 6],
//     frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontTextScale: [40, 20, 20],

//     frontNumberPosition: [0, -15, -6],
//     frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontNumberScale: [40, 20, 20],

//     frontLogoPosition: [8, -10, 15],
//     frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
//     frontLogoScale: [7.5, 7.5, 7.5],

//     backTextPosition: [0, 15, 6],
//     backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backTextScale: [40, 20, 20],

//     backNumberPosition: [0, 15, -6],
//     backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backNumberScale: [40, 20, 20],

//     backLogoPosition: [8, 13, 15],
//     backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
//     backLogoScale: [7.5, 7.5, 7.5],

//     logoPosition: [0, 0, -0.005],
//     logoRotation: [-Math.PI / 2, 0, 0],
//     logoScale: 0.01,
//  },

   kidskidsbasketballjersey:{
 overallScale: 736,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.01,0.01,0.01],
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
 fontSize: 120,
     fontSizeNumber: 270,
        frontTextPosition: [0, -0.15, 0.13],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    frontNumberPosition: [0, -0.02, 0.13],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [0.6, 0.27, 0.06],

    frontLogoPosition: [0.07, 0.15, 0.10],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.12, 0.8, 0.1],

    backTextPosition: [0, -0.15, -0.12],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.11],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [0.6, 0.27, 0.06],

    backLogoPosition: [-0.07, 0.15, -0.105],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.12, 0.8, 0.1],

    logoPosition: [0, 0, 0.00035],
    logoRotation: [0, 0, 0],
    logoScale: 0.04,
  },
  menmencitycollection:{
overallScale: 6,
    position: [0, -1.315, 0],
    rotation: [Math.PI / 2, 0, 0],
    scale: 0.001,
    patternScalling: 750,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    fontSize: 120,
    fontSizeNumber: 270,

     frontTextPosition: [0, 100, -1150],
    frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
    frontTextScale: [300, 250, 200],

    frontNumberPosition: [0, 100, -1350],
    frontNumberRotation: [(3 * Math.PI) / 2, 0, 0],
    frontNumberScale: [300, 250, 200],

    frontLogoPosition:  [60, 80, -1450],
    frontLogoRotation: [(3 * Math.PI) / 2, 0, 0],
    frontLogoScale: [60, 60, 60],

    backTextPosition: [0, -100, -1150],
    backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backTextScale: [300, 250, 200],

    backNumberPosition: [0, -100, -1350],
    backNumberRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backNumberScale: [300, 250, 200],

    backLogoPosition: [60, -150, -1450],
    backLogoRotation: [(3 * Math.PI) / 2, Math.PI, 0],
    backLogoScale: [60, 60, 60],

    logoPosition: [0, 0, -0.005],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
menmenxjersey:{
 overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
},
  kidskidscricketshorts: {
    overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },

  kidskidsshorts: {
      overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  
  kidskidscyclingshorts: {
      overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   kidskidsrunningshorts: {
      overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   kidskidswovenshorts: {
    overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   kidskidsknittedshorts: {
      overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
   kidskidsbasketballshorts: {
     overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
     kidskidssoccershorts: {
      overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
     kidskidsfootballshorts: {
      overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
  
  kidskidsnftfootballshorts: {
     overallScale: 13,
    position: [0, 0.024, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.023,0.023,0.023],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 3],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 3],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    // logoPosition: [-0.037, -0.045, 0.011],
     logoPosition: [-0.006, -0.161, 0.001],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },
kidskidscompressionpants: {
  overallScale: 6,
  position: [0, 0, 0],
  rotation: [-Math.PI / 2, 0, 0],
  scale: [0.022, 0.022, 0.022],
  patternScalling: 750,
  partMappings: {
    TRACK: ["LEFT LEG", "RIGHT LEG"],
  },
  fontSize: 100,
  fontSizeNumber: 270,
  frontTextPosition: [0, -5, 10],
  frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
  frontTextScale: [20, 10, 10],
  frontNumberPosition: [-3.5, -5, 5],
  frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
  frontNumberScale: [10, 10, 10],
  frontLogoPosition: [4, -3, 3],
  frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
  frontLogoScale: [2.5, 2.5, 2],
  backTextPosition: [0, 5, 10],
  backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
  backTextScale: [20, 10, 10],
  backNumberPosition: [-3.5, 5, 5],
  backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
  backNumberScale: [10, 10, 10],
  backLogoPosition: [4, 3, 3],
  backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
  backLogoScale: [2.5, 2.5, 2],

  logoPosition: [-0.013, 0.02, 0],
  logoRotation: [-Math.PI / 2, 0, 0],
  logoScale: 0.01,
},
   kidskidstrackpants: {
    overallScale: 6,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.022,0.022,0.022],
    patternScalling: 750,
    partMappings: {
      TRACK: ["LEFT LEG", "RIGHT LEG"],
    },
 fontSize: 100,
    fontSizeNumber: 270,
   frontTextPosition: [0, -5, 10],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [20, 10, 10],

    frontNumberPosition: [-3.5, -5, 5],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale:  [10, 10, 10],

    frontLogoPosition: [4, -3, 3],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [2.5, 2.5, 2],

    backTextPosition: [0, 5, 10],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [-3.5, 5, 5],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [10, 10, 10],

    backLogoPosition: [4, 3, 3],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [2.5, 2.5, 2],

    logoPosition: [-0.013, 0, 0],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.01,
  },

  menmenfootballjersey: {
    overallScale: 8.417,
    position: [0, -0.003, -0.029],
    rotation: [0, 0, 0],
    // scale: 9.717,
    scale: [1.717,1.717,1.717],

    // designposition: [0, -0.003, -0.015],
    // designrotation:[0, 0, 0],
    // designscale: 1.717,

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

    patternScalling: 0.717,

    fontSize: 120,
    fontSizeNumber: 400,
    frontTextPosition: [0, 0.05, 0.1],
    frontTextRotation: [0, 0, 0],
    // frontTextScale: [0.1, 0.07, 0.2],
    frontTextScale: [0.19, 0.065, 0.2],

    frontNumberPosition: [0, -0.06, 0.1],
    frontNumberRotation: [0, 0, 0],
    // frontNumberScale: [2, 0.77, 0.1],
    frontNumberScale: [0.2, 0.15, 0.2],

    frontLogoPosition: [0.04, 0.12, 0.1],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.04, 0.03, 0.07],

    backTextPosition: [0, 0.05, -0.1],
    backTextRotation: [0, Math.PI, 0],
    // backTextScale: [0.25, 0.1, 0.1],
    backTextScale: [0.19, 0.065, 0.2],

    backNumberPosition: [0, -0.06, -0.1],
    backNumberRotation: [0, Math.PI, 0],
    // backNumberScale: [2, 0.77, 0.1],
    backNumberScale: [0.2, 0.15, 0.2],

    backLogoPosition: [-0.04, 0.13, -0.07],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.04, 0.03, 0.07],

    // logoPosition:[0, 0.003, 0.029],
    // logoRotation: [-0.109, 0, 0],
    // logoScale: 20.717,
    logoPosition: [0, 0.003, 0.029],
    logoRotation: [-0.109, 0, 0],
    logoScale: 1.717,
  },

  kidskidsxjersey: {
      overallScale: 165.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.05,0.05,0.05],
    // scale: 0.07,
    // patternScalling : 0.717,
    frontTextPosition: [0, -0.15, 0.14],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],

    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontNumberPosition: [0, -0.02, 0.14],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0, 0.1, 0.15],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.14],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.14],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [0, 0.1, -0.15],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.0006],
    logoRotation: [0, 0, 0],
    logoScale: 0.05,
  },

  womenwomencricketjersey: {
    overallScale: 8,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.012,0.012,0.012],
    // scale: 0.016,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    patternScalling: 100,
    frontTextPosition: [0, -13.5, -14],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 14, 9],

    frontNumberPosition: [0, -13.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [130, 80, 9],

    frontLogoPosition: [5, -9.5, 15],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 7, 9],

    backTextPosition: [0, 13.5, -14],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 13.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [-5, 9.5, 15],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 7, 9],

    logoPosition: [0, 0, 0.008],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.012,
  },
  womenwomenbadmintontanktop: {
    overallScale: 8,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [2.076,2.076,2.076],

    // scale: 2.776,

    partMappings: {
      SLEVES: ["LEFT SIDE PANEL", "RIGHT SIDE PANEL"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    patternScalling: 1,
    frontTextPosition: [0, -0.07, 0.075],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.2, 0.1, 0.1],

    frontNumberPosition: [0, 0, 0.075],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [0.6, 0.4, 0.1],

    frontLogoPosition: [0.04, 0.06, 0.075],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.05, 0.03, 0.1],

    backTextPosition: [0, -0.07, -0.075],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.2, 0.1, 0.1],

    backNumberPosition: [0, 0, -0.075],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [0.6, 0.4, 0.1],

    backLogoPosition: [-0.04, 0.06, -0.075],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.05, 0.03, 0.1],

    logoPosition: [0, 0, 0.006],
    logoRotation: [0, 0, 0],
    logoScale: 2.076,
  },
  womenwomenarmsleeves: {
    overallScale: 8,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [2.076,2.076,2.076],

    // scale: 2.776,

    partMappings: {
      SLEVES: ["LEFT SIDE PANEL", "RIGHT SIDE PANEL"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    patternScalling: 1,
    frontTextPosition: [0, -0.07, 0.075],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.2, 0.1, 0.1],

    frontNumberPosition: [0, 0, 0.075],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [0.6, 0.4, 0.1],

    frontLogoPosition: [0.04, 0.06, 0.075],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.05, 0.03, 0.1],

    backTextPosition: [0, -0.07, -0.075],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.2, 0.1, 0.1],

    backNumberPosition: [0, 0, -0.075],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [0.6, 0.4, 0.1],

    backLogoPosition: [-0.04, 0.06, -0.075],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.05, 0.03, 0.1],

    logoPosition: [0, 0, 0.006],
    logoRotation: [0, 0, 0],
    logoScale: 2.076,
  },
  womenwomensinglet: {
     overallScale: 8,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [2.076,2.076,2.076],

    // scale: 2.776,

    partMappings: {
      SLEVES: ["LEFT SIDE PANEL", "RIGHT SIDE PANEL"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    patternScalling: 1,
    frontTextPosition: [0, -0.07, 0.075],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.2, 0.1, 0.1],

    frontNumberPosition: [0, 0, 0.075],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [0.6, 0.4, 0.1],

    frontLogoPosition: [0.04, 0.06, 0.075],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.05, 0.03, 0.1],

    backTextPosition: [0, -0.07, -0.075],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.2, 0.1, 0.1],

    backNumberPosition: [0, 0, -0.075],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [0.6, 0.4, 0.1],

    backLogoPosition: [-0.04, 0.06, -0.075],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.05, 0.03, 0.1],

    logoPosition: [0, 0, 0.006],
    logoRotation: [0, 0, 0],
    logoScale: 2.076,
  },
  womenwomenxjersey: {
    overallScale: 218.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.04, 0.04, 0.04],
    // scale: 0.055,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -0.15, 0.17],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],
    patternScalling: 100,
    frontNumberPosition: [0, -0.02, 0.18],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0.07, 0.15, 0.16],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.12],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.11],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [-0.07, 0.15, -0.105],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.00035],
    logoRotation: [0, 0, 0],
    logoScale: 0.04,
  },
  kidskidscricketjersey: {
    overallScale: 9.917,
    position: [0, -0.001, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.011, 0.012, 0.012],
    // scale: [0.0165, 0.0165, 0.0165],
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

      fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -8.5, -10],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 14, 9],

    frontNumberPosition: [0, -8.5, 1],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [150, 104, 9],

    frontLogoPosition: [5, -8.5, 14],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 7, 9],

    backTextPosition: [0, 8.5, -10],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 14, 9],

    backNumberPosition: [0, 8.5, 1],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [150, 104, 9],

    backLogoPosition: [-5, 10.5, 14],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 7, 9],

    logoPosition: [0, 0, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.011, 0.012, 0.012],
  },
  // menfootballjersey: {
  //   overallScale: 5.717,
  //   position: [0.001, -0.001, 0],
  //   rotation: [Math.PI / 2, 0, 0],
  //   scale: 0.005,
  //   patternScalling: 100,
  //   partMappings: {
  //     LEFTSLEVE: ["LEFT SLEEVE"],
  //     RIGHTSLEVE: ["RIGHT SLEEVE"],
  //     TEE: ["FRONT", "BACK"],
  //   },
  //   frontTextPosition: [0, 145, 8],
  //   frontTextRotation: [(3 * Math.PI) / 2, 0, 0],
  //   frontTextScale: [340, 220, 110],

  //   backTextPosition: [0, -145, 8],
  //   backTextRotation: [(3 * Math.PI) / 2, Math.PI, 0],
  //   backTextScale: [340, 220, 110],
  // },
  kidskidscyclingjersey: {
    overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.03,0.03,0.03],
    // scale: 0.045,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

      fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -3.5, 0],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 5, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0, 0, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.03,
  },
    kidskidsracefitjersey: {
    overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.03,0.03,0.03],
    // scale: 0.045,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

      fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -3.5, 0],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 5, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0, 0, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.03,
  },
    kidskidswinterjersey: {
    overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.03,0.03,0.03],
    // scale: 0.045,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

      fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -3.5, 0],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 5, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0, 0, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.03,
  },
      kidskidscitycollection: {
    overallScale: 9.717,
    position: [0, 0, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.03,0.03,0.03],
    // scale: 0.045,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

      fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -3.5, 0],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 5, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0, 0, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.03,
  },

  kidskidsjersey: {
    overallScale: 9.717,
    position: [0.002, 0.007, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.029,0.029,0.029],
    // scale: 0.04,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -4.9, -0.5],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 3, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0.002, 0.007, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.029,
  },
  kidskidsprotshirt: {
      overallScale: 9.717,
    position: [0.002, 0.007, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.029,0.029,0.029],
    // scale: 0.04,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -4.9, -0.5],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 3, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0.002, 0.007, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.029,
  },
    kidskidsfootballjersey: {
    overallScale: 9.717,
    position: [0.002, 0.007, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.029,0.029,0.029],
    // scale: 0.04,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -4.9, -0.5],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 3, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0.002, 0.007, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.029,
  },
    kidskidssoccerjersey: {
    overallScale: 9.717,
    position: [0.002, 0.007, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.029,0.029,0.029],
    // scale: 0.04,
    patternScalling: 70,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },
    frontTextPosition: [0, -3.5, -5],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [8, 6, 3],

    frontNumberPosition: [0, -4.9, -0.5],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [38, 26, 13],

    frontLogoPosition: [1.9, -3, 4.5],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [3.5, 3, 3],

    backTextPosition: [0, 3.5, -5],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [8, 6, 3],

    backNumberPosition: [0, 4, 0],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [38, 26, 13],

    backLogoPosition: [-1.9, 3, 4.5],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [3.5, 3, 3],

    logoPosition: [0.002, 0.007, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: 0.029,
  },

  kidskidstanktop: {
    overallScale: 13.417,
    position: [0, -0.008, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.005, 0.007, 0.006],
    // scale: [0.0075, 0.0085, 0.0075],
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -12, -13],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 10, 15],

    frontNumberPosition: [0, -11, 6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [160, 70, 10],

    frontLogoPosition: [5, -9, 22],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 8, 10],

    backTextPosition: [0, 12, -13],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [0, 11, 6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [160, 70, 10],

    backLogoPosition: [5, 14, 22],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 8, 10],

    logoPosition: [0, -0.008, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.007, 0.006],
  },
    kidskidssinglet: {
    overallScale: 13.417,
    position: [0, -0.008, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.005, 0.007, 0.006],
    // scale: [0.0075, 0.0085, 0.0075],
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -12, -13],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 10, 15],

    frontNumberPosition: [0, -11, 6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [160, 70, 10],

    frontLogoPosition: [5, -9, 22],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 8, 10],

    backTextPosition: [0, 12, -13],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [0, 11, 6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [160, 70, 10],

    backLogoPosition: [5, 14, 22],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 8, 10],

    logoPosition: [0, -0.008, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.007, 0.006],
  },
  kidsbaseballjerseykids: {
    overallScale: 9.417,
    position: [-0.002, -1.043, -0.007],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.027,0.027,0.027],
    // scale: [0.0075, 0.0085, 0.0075],
    patternScalling: 100,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -12, -13],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 10, 15],

    frontNumberPosition: [0, -11, 6],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [160, 70, 10],

    frontLogoPosition: [5, -9, 22],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 8, 10],

    backTextPosition: [0, 12, -13],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [20, 10, 10],

    backNumberPosition: [0, 11, 6],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [160, 70, 10],

    backLogoPosition: [5, 14, 22],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 8, 10],

    logoPosition: [0, -0.008, 0.01],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.007, 0.006],
  },
 kidskidsarmsleeves: {
     overallScale:8.717,
    // position: [-0.002, -1, -0.007],
    // rotation: [-Math.PI / 2, 0, 0],
    position: [-0.002, -1.043, -0.007],
    rotation: [-Math.PI / 2, 0, 0],
    scale: 0.027,

       partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

       fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -5, 33],
    frontTextRotation: [(3 * Math.PI) / 2,Math.PI,Math.PI],
    frontTextScale: [10, 5, 5],

    frontNumberPosition: [0, -4.5, 39],
    frontNumberRotation: [(3 * Math.PI) / 2,Math.PI,Math.PI],
    frontNumberScale: [60, 35, 5],

    frontLogoPosition: [3, -4, 44],
    frontLogoRotation: [(3 * Math.PI) / 2,Math.PI,Math.PI],
    frontLogoScale:[3, 3, 5],

    backTextPosition: [0, 5, 33],
    backTextRotation: [(3 * Math.PI) / 2,0,Math.PI],
    backTextScale: [10, 5, 5],

    backNumberPosition: [0, 4.5, 39],
    backNumberRotation: [(3 * Math.PI) / 2,0,Math.PI],
    backNumberScale: [60, 35, 5],

    backLogoPosition: [-3, 4.5, 44],
    backLogoRotation: [(3 * Math.PI) / 2,0,Math.PI],
    backLogoScale: [3, 3, 5],

    logoPosition:[0, 0.001, 0.01],
    logoRotation:[-Math.PI / 2, 0, 0],
    logoScale:0.027,
  },
  womenwomenbaseballjersey: {
      overallScale: 218.717,
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [0.04, 0.04, 0.04],
    // scale: 0.055,
    partMappings: {
      LEFTSLEVE: ["LEFT SLEEVE"],
      RIGHTSLEVE: ["RIGHT SLEEVE"],
      TEE: ["FRONT", "BACK"],
    },

     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -0.15, 0.17],
    frontTextRotation: [0, 0, 0],
    frontTextScale: [0.35, 0.15, 0.1],
    patternScalling: 100,
    frontNumberPosition: [0, -0.02, 0.18],
    frontNumberRotation: [0, 0, 0],
    frontNumberScale: [2, 0.77, 0.1],

    frontLogoPosition: [0.07, 0.15, 0.16],
    frontLogoRotation: [0, 0, 0],
    frontLogoScale: [0.1, 0.1, 0.1],

    backTextPosition: [0, -0.15, -0.12],
    backTextRotation: [0, Math.PI, 0],
    backTextScale: [0.35, 0.15, 0.1],

    backNumberPosition: [0, -0.02, -0.11],
    backNumberRotation: [0, Math.PI, 0],
    backNumberScale: [2, 0.77, 0.1],

    backLogoPosition: [-0.07, 0.15, -0.105],
    backLogoRotation: [0, Math.PI, 0],
    backLogoScale: [0.1, 0.1, 0.1],

    logoPosition: [0, 0, 0.00035],
    logoRotation: [0, 0, 0],
    logoScale: 0.04,
  },
  womenwomencompressionpants: {
    overallScale: 11.717,
    position: [0, -0.05, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.005,0.005,0.005],
    // scale: 0.0055,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -12, 39],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [40, 16, 15],

    frontNumberPosition: [-10, -11, 26],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [160, 90, 10],

    frontLogoPosition: [10, -11, 20],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [8, 8, 10],

    backTextPosition: [0, 12, 39],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [40, 16, 15],

    backNumberPosition: [10, 11, 19],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [160, 90, 10],

    backLogoPosition: [-10, 10, 20],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [8, 8, 10],

    logoPosition: [0.002, 0.21, -0.034],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
   menmencompressionpants: {
    overallScale: 15.717,
    position: [0, 0.01, 0],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [0.005,0.005,0.005],
    // scale: 0.0055,
    partMappings: {
      TEE: ["LEFT LEG", "RIGHT LEG"],
    },
     fontSize: 120,
    fontSizeNumber: 70,

    frontTextPosition: [0, -9, 19],
    frontTextRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontTextScale: [30, 13, 12],

    frontNumberPosition: [-5, -11, 12],
    frontNumberRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontNumberScale: [160, 90, 10],

    frontLogoPosition: [7, -7, 22],
    frontLogoRotation: [(3 * Math.PI) / 2, Math.PI, Math.PI],
    frontLogoScale: [4, 4, 6],

    backTextPosition: [0, 9, 19],
    backTextRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backTextScale: [30, 13, 12],

    backNumberPosition: [-5, 8, 12],
    backNumberRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backNumberScale: [160, 90, 10],

    backLogoPosition: [-7, 7, 22],
    backLogoRotation: [(3 * Math.PI) / 2, 0, Math.PI],
    backLogoScale: [4, 4, 6],

    logoPosition: [0.002, 0.21, -0.034],
    logoRotation: [-Math.PI / 2, 0, 0],
    logoScale: [0.005, 0.005, 0.006],
  },
};

export default modelConfig1;